import { DeedProvenanceAIAnnotationCategory } from '../domain/types';

export const aiAnnotationCategoryLabels: {
  [key in DeedProvenanceAIAnnotationCategory]: string;
} = {
  [DeedProvenanceAIAnnotationCategory.SERVITU]: 'Servitù attive e passive',
  [DeedProvenanceAIAnnotationCategory.LIMITAZIONI_PROPRIETA]: 'Limitazioni di proprietà o confini particolari',
  [DeedProvenanceAIAnnotationCategory.VINCOLI_URBANISTICI]: 'Vincoli urbanistici, ambientali o territoriali',
  [DeedProvenanceAIAnnotationCategory.LIMITAZIONI_EDILIZIE]: 'Limitazioni edilizie o funzionali',
  [DeedProvenanceAIAnnotationCategory.DIRITTI_TERZI]: 'Diritti di terzi',
  [DeedProvenanceAIAnnotationCategory.ALTRO]: 'Altri elementi che possono incidere sull\'acquirente',
};
